module.exports = __webpack_public_path__ + "static/img/banner2.e4a74518.png";